import { ElementRef } from '@angular/core';
import { TreeService } from '../services/tree.service';
import { TREE_EVENTS } from '../constants/events';
import { Response } from '@angular/http';
const _ = require('lodash');
import { Objectifier } from '../../utils/utils';
import { DELIMITER } from '../constants/keys';

export class TreeNode {
    children: TreeNode[];
    allNodes: TreeNode[];
    visibleChildren: any;
    moreNode: TreeNode;
    level: number;
    path: string[];
    idPath: string[];
    elementRef: ElementRef;
    get isHidden() { return this.getField('isHidden'); };
    set isHidden(value) { this.setField('isHidden', value); };

    private _isExpanded: boolean = false;
    get isExpanded() { return this.treeService.isExpanded(this); };
    get isActive() { return this.treeService.isActive(this); };
    get isFocused() { return this.treeService.isNodeFocused(this); };

    private _originalNode: any;
    get originalNode() { return this._originalNode; };
    private hideSystemFolders: boolean = false;

    constructor(public data: any, public parent: TreeNode = undefined,
                public treeService: TreeService) {
        this.level = this.parent ? this.parent.level + 1 : 0;
        this.path = this.parent ? [...this.parent.path, this.displayField] : [];
        this.idPath = this.parent ? [...this.parent.idPath, this.id] : [];

        if (data[this.options.isExpandedField]) {
            this.setIsExpanded(true);
        }
        if (data[this.options.childrenField]) {
            this.children = data[this.options.childrenField]
                .map(c => new TreeNode(c, this, treeService));
        }
        if (this.options.hideSystemFolders) {
            this.hideSystemFolders = this.options.hideSystemFolders;
        }
        
    }

    getField(key) {
        return this.data[this.options[`${key}Field`]];
    }

    setField(key, value) {
        this.data[this.options[`${key}Field`]] = value;
    }

    setIsExpanded(value) {
        this.treeService.setExpandedNode(this, value);

        if (!this.children && this.hasChildren && value) {
            this.loadChildren();
        }
    };

    get isCollapsed() { return !this.isExpanded; }
    get isLeaf() { return !this.hasChildren; }
    get isRoot() { return this.parent.data.virtual; }
    get realParent() { return this.isRoot ? undefined : this.parent; }

    get options() { return this.treeService.options; }

    fireEvent(event) { this.treeService.fireEvent(event); }

    getLeafOfNestedObject(obj, path) {
        path = path.split('.');
        let res = obj;
        for (let i = 0; i < path.length; i++) {
            res = (typeof res[path[i]] !== "undefined") ? res[path[i]] : "";
        }
        return res;
    }

    get displayField() {
        return this.getLeafOfNestedObject(this.data, this.options.displayField);
    }

    get id() {
        return this.getLeafOfNestedObject(this.data, this.options.idField);
    }

    set id(value) {
        this.setField('id', value);
    }

    get falseId() {
        let pathStr = this.path.join();
        return this.getLeafOfNestedObject(this.data, this.options.idField) + DELIMITER + pathStr;
    }

    set falseId(value) {
        this.setField('falseId', value);
    }

    get hasChildren(): boolean {
        if (this.data.isMoreField) {
            return false;
        }
        if (this.data.hasOwnProperty('hasChildren')) {
            return !!(this.data.hasChildren || (this.children && this.children.length > 0));
        } else if (this.options['leafTypes']) {
            if (_.includes(this.options['leafTypes'], this.getField('type'))) {
                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    findAdjacentSibling(steps) {
        let index = this._getIndexInParent();
        return this._getParentsChildren()[index + steps];
    }

    findNextSibling() {
        return this.findAdjacentSibling(+1);
    }

    findPreviousSibling() {
        return this.findAdjacentSibling(-1);
    }

    getFirstChild() {
        return _.first(this.children || []);
    }

    getLastChild() {
        return _.last(this.children || []);
    }

    findNextNode(goInside = true) {
        return goInside && this.isExpanded && this.getFirstChild() ||
            this.findNextSibling() ||
            this.parent && this.parent.findNextNode(false);
    }

    findPreviousNode() {
        let previousSibling = this.findPreviousSibling();
        if (!previousSibling) {
            return this.realParent;
        }
        return previousSibling._getLastOpenDescendant();
    }

    _getLastOpenDescendant() {
        return this.isCollapsed ? this : this.getLastChild()._getLastOpenDescendant();
    }

    removeHiddenFolders(nodes = []) {
        let resultNodes = [];
        let entityId: string;
        nodes.forEach(function(node) {
            entityId = node['entity_id'];
            if (entityId.indexOf('group-h') === -1 && 
                entityId.indexOf('group-s') === -1 && 
                entityId.indexOf('group-n') === -1) {
                resultNodes.push (node);
            }
        })
        return resultNodes;
    }

    loadChildren(refresh = false) {
        if (!this.options.getChildren) {
            return Promise.resolve();
        }
        Promise.resolve(this.options.getChildren(this))
            .then((children) => {
                let allChildren = [];
                if (children && children instanceof Response) {
                    allChildren = children.json();
                } else if (children instanceof Array) {
                    allChildren = children;
                }
                if (this.hideSystemFolders) {
                    allChildren = this.removeHiddenFolders(allChildren);
                }
                this.allNodes = _.cloneDeep(allChildren);
                if (this.options['limitChildCount'] && allChildren.length > this.options['limitChildCount']){
                    this.visibleChildren = _.slice(allChildren, 0, this.options['limitChildCount']);
                    let numHidden = allChildren.length - this.options['limitChildCount'];
                    let moreObj = { 'isMoreField': true };
                    Objectifier.set(this.options[`displayField`], numHidden + ' more', moreObj);
                    let type = _.toLower(this.data[this.options[`typeField`]]);
                    Objectifier.set(this.options[`idField`],  this.id , moreObj);
                    Objectifier.set(this.options[`typeField`], this.data[this.options[`typeField`]], moreObj);
                    this.visibleChildren.push(moreObj);
                    this.setField('children', this.visibleChildren);
                } else {
                    this.setField('children', allChildren);
                }
                this.initChildren();
                if (refresh) {
                    this.children.forEach((node) => {
                        this.treeService.previousExpandedNodes.forEach((n) => {
                            if (node.falseId === n.falseId) {
                                if (!node.children) {
                                    node.loadChildren(true);
                                }
                            }
                        });
                    });
                } else {
                    let idsFromUrl = this.treeService.getIdsFromUrl();
                    if (idsFromUrl && idsFromUrl.ids) {
                            this.children.forEach((node) => {
                                let pos = idsFromUrl.ids.indexOf(node.id);
                                if (pos >= 0) {
                                    if (pos === (idsFromUrl.ids.length - 1)) {
                                        node.blur();
                                        node.focus();
                                    }
                                    if (idsFromUrl.item === 'compute' && !node.children && node.level < 4) {
                                        node.loadChildren(false);
                                    }
                                }

                            });
                    }
                }
                this.treeService.update();
            }).then(() => {
            this.fireEvent({
                eventName: TREE_EVENTS.onLoadChildren,
                node: this,
                refresh: refresh
            });
        });
    }

    initChildren() {
        this.children = this.getField('children')
            .map(c => new TreeNode(c, this, this.treeService));
    }

    setIsActive(value, multi = false) {
        this.treeService.setActiveNode(this, value, multi);
        if (value) {
            this.fireEvent({ eventName: TREE_EVENTS.onActivate, node: this });
            this.focus();
        } else {
            this.fireEvent({ eventName: TREE_EVENTS.onDeactivate, node: this });
        }
    }

    rightClick(event: MouseEvent) {
        this.fireEvent({
            eventName: TREE_EVENTS.onRightClick,
            node: this, isExpanded: this.isExpanded
        });
        event.preventDefault();

    }

    getIconClass() {
        if (!this.options.getIconClass) {
            throw new Error('Node does not have getIconClass method');
        }
        return this.options.getIconClass(this);
    }

    expand() {
        if (!this.isExpanded) {
            this.toggleExpanded();
        }
    }

    collapse() {
        if (this.isExpanded) {
            this.toggleExpanded();
        }
    }

    toggle() {
        if (this.hasChildren) {
            this.toggleExpanded();
        }
    }

    toggleExpanded() {
        this.setIsExpanded(!this.isExpanded);
        this.fireEvent({ eventName: TREE_EVENTS.onToggle, node: this,
            isExpanded: this.isExpanded });
        this.fireEvent({ eventName: TREE_EVENTS.onToggleExpanded, node: this,
            isExpanded: this.isExpanded });
    }

    toggleActivated(multi = false) {
        this.setIsActive(!this.isActive, multi);
        this.fireEvent({ eventName: TREE_EVENTS.onActiveChanged, node: this,
            isActive: this.isActive });
    }

    activated(multi = false) {
        this.setIsActive(true, multi);
        this.fireEvent({ eventName: TREE_EVENTS.onActiveChanged, node: this,
            isActive: this.isActive });
    }

    focus() {
        let previousNode = this.treeService.getFocusedNode();
        this.treeService.setFocusedNode(this);
        if (previousNode) {
            this.fireEvent({ eventName: TREE_EVENTS.onBlur, node: previousNode });
        }
        this.fireEvent({
            eventName: TREE_EVENTS.onFocus,
            node: this
        });
    }

    blur() {
        let previousNode = this.treeService.getFocusedNode();
        this.treeService.setFocusedNode(undefined);
        if (previousNode) {
            this.fireEvent({
                eventName: TREE_EVENTS.onBlur,
                node: this
            });
        }
    }
    doubleClick(event: MouseEvent) {
        if (this.hasChildren) {
            this.toggle();
        }
        this.fireEvent({
            eventName: TREE_EVENTS.onDoubleClick,
            node: this,
            isExpanded: this.isExpanded
        });
    }

    contextmenu(object) {
        let action;
        if (object.linkName) {
            action = this.options.contextMenuActionMapping[object.linkName];
        }
        if (action) {
            action(this.treeService, this);
        }
    }

    ensureVisible() {
        if (this.realParent) {
            this.realParent.expand();
            this.realParent.ensureVisible();
        }

        return this;
    }

    filter(filterFn, autoShow = false) {
        let isVisible = filterFn(this);
        if (this.children) {
            this.children.forEach((child) => {
                child.filter(filterFn, autoShow);
                isVisible = isVisible || !child.isHidden;
            });
        }

        this.isHidden = !isVisible;
        if (autoShow) {
            this.ensureVisible();
        }
    }

    clearFilter() {
        this.isHidden = false;
        if (this.children) this.children.forEach((child) => child.clearFilter());
    }

    private _getParentsChildren() {
        return _.get(this, 'parent.children') || [];
    }

    private _getIndexInParent() {
        return this._getParentsChildren().indexOf(this);
    }
}



// WEBPACK FOOTER //
// ./src/common/tree/models/tree-node.model.ts